import { getPrimaryColor } from '@orcar/common-d2c';
import styled from 'styled-components';

const app = import.meta.env.VITE_PACKAGE_NAME;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 26px;
`;

export const SideTab = styled.div`
  position: sticky;
  top: 150px;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  ${({ theme }) => theme.FONT.H1}
  margin-bottom : 40px;
`;

export const Tab = styled.div<{ isActive?: boolean }>`
  margin: 20px 0;
  font-weight: 600;
  color: ${({ theme, isActive }) =>
    isActive ? getPrimaryColor(app) : theme.COLOR.GREY_01};
  cursor: pointer;
`;

export const EventsWrapper = styled.div`
  width: 792px;
  border-top: 1px solid #ececec;
  display: flex;
  flex-direction: column;
`;

export const CurrentTitle = styled.div`
  margin: 60px 0 30px 0;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.FONT.H3}
`;

export const SubTab = styled.div<{ isActive?: boolean }>`
  ${({ theme }) => theme.FONT.B1};
  line-height: 19.09px;
  margin-bottom: 12px;
  color: ${({ theme, isActive }) =>
    isActive ? theme.COLOR.PRIMARY : theme.COLOR.GREY_01};
  cursor: pointer;
`;
